//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  name: 'Lang',
  inject: ['parentRoot'],
  data() {
    return {
      langsShow: false,
      langImg: {
        en_US: require('../../../assets/image/langs/en_US.png'),
        hi_IN: require('../../../assets/image/langs/hi_IN.png')
      },
      lang: ''
    }
  },
  computed: {
    ...mapState({
      langs: state => state.langs
    }),
    langsLogo() {
      return require(`../../../assets/image/langs/hi_IN.png`)
    },
    langsMenu() {
      const { keys, langsOptions } = this.langs
      return langsOptions[keys]
    }
  },
  created() {},
  mounted() {
    this.lang = this.langs.keys
  },
  methods: {
    showLang(){
      this.langsShow = !this.langsShow
    },
    handleSetLang(lang) {
      // 设置i18n.locale 组件库会按照上面的配置使用对应的文案文件
      this.$i18n.locale = lang
      // 提交mutations
      this.$Cookies.set('lang', lang)
      this.$store.commit('setlangs' ,{ keys: lang })
      // window.location.reload()
      this.parentRoot.reload()
    },
    setLang() {
      this.$i18n.locale = this.lang
      // 提交mutations
      this.$Cookies.set('lang', this.lang)
      this.$store.commit('setlangs' ,{ keys: this.lang })
      // window.location.reload()
      this.parentRoot.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/components/Lang/index.vue